(function () {
  "use strict";

  if (window.__cordialCraftInteractionBridgeInitialized) return;
  window.__cordialCraftInteractionBridgeInitialized = true;

  function safeToken(value, fallback) {
    var token = String(value || fallback || "interaction").toLowerCase()
      .replace(/[^a-z0-9_-]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 64);
    return token || fallback || "interaction";
  }

  function targetPath(element) {
    if (!element || !element.href) return "";
    try {
      var url = new URL(element.href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : "external";
    } catch (error) {
      return "";
    }
  }

  function emit(element, interactionName) {
    var payload = {
      event: "cc_interaction",
      interaction_name: safeToken(interactionName, "interaction"),
      interaction_label: safeToken(
        element && (
          element.getAttribute("data-cc-event-label") ||
          element.getAttribute("data-cc-label") ||
          element.getAttribute("data-cc-section")
        ),
        "unlabeled"
      ),
      element_type: safeToken(element && element.tagName, "element"),
      page_path: window.location.pathname,
      target_path: targetPath(element)
    };
    document.dispatchEvent(new CustomEvent("cc:interaction", { detail: payload }));

    var shopifyAnalytics = window.Shopify && window.Shopify.analytics;
    if (shopifyAnalytics && typeof shopifyAnalytics.publish === "function") {
      try {
        Promise.resolve(
          shopifyAnalytics.publish("cordial_craft:interaction", payload)
        ).catch(function () {});
      } catch (error) {}
    }
  }

  document.addEventListener("click", function (event) {
    if (!event.target || !event.target.closest) return;
    var element = event.target.closest("[data-cc-event], [data-cta]");
    if (!element) return;
    // A submit button click bubbles through its annotated form.  Let the
    // submit listener below be the sole source for form-attempt telemetry so
    // one user action cannot produce both click and submit copies.
    if (element.tagName === "FORM" || element.tagName === "DETAILS") return;
    if (element.matches("input[data-cc-event], select[data-cc-event], textarea[data-cc-event]")) return;
    emit(element, element.getAttribute("data-cc-event") || element.getAttribute("data-cta"));
  });

  // Form controls are change-driven so a label/card click and a direct control
  // click produce one event after the selected state actually changes.
  document.addEventListener("change", function (event) {
    var element = event.target;
    if (!element || !element.matches) return;
    if (!element.matches("input[data-cc-event], select[data-cc-event], textarea[data-cc-event]")) return;
    emit(element, element.getAttribute("data-cc-event") || "control_change");
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches("form[data-cc-event]")) return;
    emit(form, form.getAttribute("data-cc-event") || "form_submit");
  });

  document.querySelectorAll("details[data-cc-event]").forEach(function (element) {
    element.addEventListener("toggle", function () {
      if (!element.open) return;
      emit(element, element.getAttribute("data-cc-event") || "details_open");
    });
  });

  document.querySelectorAll("[data-cc-event-view]").forEach(function (element) {
    if (element.hasAttribute("data-cc-event-view-sent")) return;
    element.setAttribute("data-cc-event-view-sent", "true");
    emit(element, element.getAttribute("data-cc-event-view") || "view");
  });
})();
